export const PASSWORD = new RegExp(/^[A-Za-z]\w{7,14}$/)
export const PHONE_NUMBER = new RegExp(/^[0-9]+$/)
export const HEX_COLOR = new RegExp(/^#[0-9A-Fa-f]{6}$/)